export default {"src":"/_next/static/media/interest-based-targeting.b2b57669.svg","height":42,"width":41,"blurWidth":0,"blurHeight":0};